export const EVENTS_API_TAGS = ['SearchEvents', 'GetEventById'];
export const MAX_EVENTS_PER_DAY = 3;
